import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { ParseLogItemByEntityService } from '@sb-tools/typescript/services/parse-log-item-by-entity.service';
import { HighlightEntityType } from '@sb-tools/typescript/enums/highlight-entity-type.enum';
import { RightPanelType } from '../../../core/enums/right-panel-type.enum';
import { RightPanelService } from '../../../core/services/right-panel.service';
import { UserAvatarComponent } from '../../../../sb-modules/Frontend-User-Avatar-Module/user-avatar.component';
import { RouterLink } from '@angular/router';
import { ReplyQuoteComponent } from '../reply-quote/reply-quote.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReplaceEmojisPipe } from '../../../../sb-tools/typescript/pipes/replace-emoji/replace-emojis.pipe';

@Component({
    selector: 'app-highlight-entity',
    templateUrl: './highlight-entity.component.html',
    styleUrls: ['./highlight-entity.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [UserAvatarComponent, RouterLink, ReplyQuoteComponent, TranslateModule, ReplaceEmojisPipe],
})
export class HighlightEntityComponent implements OnInit {
    @Input() entity: any;
    @Input() ticketId: number;

    highlightEntityTypeEnum = HighlightEntityType;
    logStringArray = [];
    rightPanelTypeEnum = RightPanelType;

    constructor(
        public commonDataService: CommonDataService,
        public rightPanelService: RightPanelService,
        private parseLogItemByEntityService: ParseLogItemByEntityService,
    ) {}

    ngOnInit() {
        this.logStringArray = this.parseLogItemByEntityService.parse(this.entity);
    }
}
